module.exports = __webpack_public_path__ + "img/authenticator.appstore.e2b62f53.png";